import { type FavoriteItem, type GTM } from '@vakantiesnl/types';
import Cookies from 'universal-cookie';

import { eventName } from './common';
import { featureTogglesFormatter } from './util/featureTogglesFormatter';
import { getConsentData } from './util/getConsentData';
import { ApplicationStoreSchema } from '../schemas/ApplicationStoreSchema';
import { APP_STATE_STORAGE_NAME } from '../stores/applicationStore';

export type BasicGTMV2EventProps = Omit<
	GTM.GTMEventV2,
	'event' | 'vendor_ids' | 'user_id' | 'ga_id' | 'user_details' | 'uid'
> & { email?: string | null };

export const basicGTMV2Event = ({
	action,
	atom,
	entity_id,
	entity_level,
	label,
	molecule,
	organism,
	page_type,
	sub_page,
	type,
	value,
	email,
	_clear,
}: BasicGTMV2EventProps): GTM.GTMEventV2 => {
	let experiment = undefined;
	let userId = '';
	let favorites: FavoriteItem[] = [];

	try {
		const appState = localStorage.getItem(APP_STATE_STORAGE_NAME);
		const parsedAppState = appState ? JSON.parse(appState) : null;

		const applicationStore = ApplicationStoreSchema.safeParse(parsedAppState);

		if (applicationStore.success) {
			favorites = applicationStore.data.state.favorites;
			experiment = featureTogglesFormatter(applicationStore.data.state.features);
			userId = applicationStore.data.state.userId;
		}
	} catch (err) {
		// eslint-disable-next-line no-console
		console.error('Failed to retrieve or parse feature toggle data from local: ', err);
	}

	return {
		event: eventName(),
		vendor_ids: new Cookies().get('consentVendorIds'),
		user_id: new Cookies().get('mcparam'),
		uid: userId,
		ga_id: new Cookies().get('_ga'),
		user_details: {
			email: email ?? null,
		},
		type,
		organism, //Ex. filter, sorting
		molecule, //Ex. acco_type, service
		atom, //Ex. checkbox, button, link, image
		action,
		label, //Ex. camping, zwembad
		page_type, //Example: accommodation, listing, etc.
		sub_page, //Example: overview, photos
		entity_id,
		entity_level, //Example: country, region, destination, accommodation, poi
		value: {
			...value,
			experiment,
			favorites,
			...getConsentData(),
		},
		_clear: _clear ?? true,
	};
};
